<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">
    <div class="modal-header bg-light">

        <h4 class="modal-title">{{headerText}}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true" class="strong">&times;</span>
        </button>
    
    </div>
    <div class="modal-body bg-light">
        <div class="row m-1">
            <p class=""> {{bodyText}}</p>
        </div>
        <!-- <div class="row m-1">
            <p class=""> {{}}</p>
        </div> -->
        <div class="row">
            <ul>
                <li *ngFor="let country of countryList">
                    {{country}}
                </li>
            </ul>
        </div>
    </div>
    
    <div class="modal-footer bg-light">
    
        <span class="mr-auto">
            {{footerText}}
        </span>
        <button class=" btn btn-outline-dark float-end" (click)="close()">{{'home.quote.Close'|cxTranslate}}</button>
    
    </div>
</div>
